import { render, staticRenderFns } from "./multi-column.vue?vue&type=template&id=07720ad4&scoped=true&"
import script from "./multi-column.vue?vue&type=script&lang=js&"
export * from "./multi-column.vue?vue&type=script&lang=js&"
import style0 from "./multi-column.vue?vue&type=style&index=0&id=07720ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07720ad4",
  null
  
)

export default component.exports